import { render, staticRenderFns } from "./lifeservice.vue?vue&type=template&id=2dcc135c&scoped=true&"
import script from "./lifeservice.vue?vue&type=script&lang=js&"
export * from "./lifeservice.vue?vue&type=script&lang=js&"
import style0 from "./lifeservice.vue?vue&type=style&index=0&id=2dcc135c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc135c",
  null
  
)

export default component.exports